import { render, staticRenderFns } from "./EnergyTrend.vue?vue&type=template&id=2ffb467b&scoped=true&"
import script from "./EnergyTrend.vue?vue&type=script&lang=js&"
export * from "./EnergyTrend.vue?vue&type=script&lang=js&"
import style0 from "./EnergyTrend.vue?vue&type=style&index=0&id=2ffb467b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffb467b",
  null
  
)

export default component.exports